import { render, staticRenderFns } from "./ClassDelayReview.vue?vue&type=template&id=29e69c34"
import script from "./ClassDelayReview.vue?vue&type=script&lang=js"
export * from "./ClassDelayReview.vue?vue&type=script&lang=js"
import style0 from "./ClassDelayReview.vue?vue&type=style&index=0&id=29e69c34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports